import { Collapse } from 'bootstrap';
import Mark from 'mark.js';

function accordionSearch(): void {
  let accordionSearchForms = document.querySelectorAll<HTMLFormElement>('.accordion-search-form');
  if (accordionSearchForms) {
    accordionSearchForms.forEach(f => {
      f.addEventListener('submit', submitAccordionSearch);
    });
  }
}

function submitAccordionSearch(event: Event): void {
  event.preventDefault();
  const form = event.target as HTMLFormElement;
  const regExpTerm = new RegExp(form.querySelector<HTMLInputElement>('input[name="q"]')?.value, 'gi');
  const accordionId = form.dataset.accordionTarget;
  const accordion = document.querySelector<HTMLElement>(`.accordion[data-accordion-id="${accordionId}"]`);

  if (accordion) {
    const mark = new Mark(accordion);
    mark.unmark();
    mark.markRegExp(regExpTerm, { element: 'span', className: 'highlight' });

    const collapses = accordion.querySelectorAll<HTMLElement>('.accordion-collapse');
    let matchFound = false;

    // Expand the collapses containing the matched text
    collapses.forEach(c => {
      const bsCollapse = Collapse.getOrCreateInstance(c, { toggle: false });

      if (c.parentElement.textContent.match(regExpTerm)) {
        matchFound = true;
        bsCollapse.show();
      } else {
        bsCollapse.hide();
      }
    });

    // Show/hide no results message, and scroll user to first match
    const noResultsElement = form.querySelector('.accordion-search-form-no-results');
    if (matchFound) {
      noResultsElement?.classList.add('d-none');
      const firstHighlight = accordion.querySelector<HTMLElement>('.highlight');
      if (firstHighlight) {
        firstHighlight.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      noResultsElement?.classList.remove('d-none');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  accordionSearch();
});
